import { createListenerMiddleware } from "@reduxjs/toolkit";
import {
  fetchProfilo,
  fetchIstitutiScolastici,
  fetchIstitutiScolasticiSuccess,
  fetchIstitutiScolasticiFailed,
  fetchIncarichi,
  fetchIncarichiSuccess,
  fetchIncarichiFailed,
  preparaListaIncarichi,
  preparaListaIstituti,
  fetchNotAuthorizedInfo,
  fetchProfiloSuccess,
  estraiDatiPrfoilo,
  PROFILO_DISABILITATO,
  inserisciProfilo,
  aggiornaProfilo,
  preparaDatiInserimento,
  preparaDatiAggiornamento,
  inserimentoProfiloFailed,
} from "./index";
import { getUserInfoSuccess } from "../common";
import { NOT_AUTHORIZED_EVENT, createRequest } from "../../utility";
import {
  AGGIORNA_PROFILO_API,
  AGGIORNA_RUOLO_ISTITUTO_API,
  INSERISCI_PROFILO_API,
  ISTITUTI_SCOLASTICI_API,
  PROFILO_API,
  INCARICHI_API,
} from "../../apiUrl";

const getUserInfoSuccessWorker = (listenerApi) => listenerApi.dispatch(fetchProfilo());

const fetchProfiloWorker = (listenerApi) => {
  createRequest(PROFILO_API.method, PROFILO_API.baseUrl, PROFILO_API.apiUrl)
    .then((response) => {
      if (response != null && response.status != null) {
        if (response.status === 200) {
          const profilo = estraiDatiPrfoilo(response.data);
          if (profilo[PROFILO_DISABILITATO]) {
            listenerApi.dispatch(fetchProfiloSuccess(profilo));
            listenerApi.dispatch(fetchNotAuthorizedInfo());
          } else window.location.href = window.origin;
        } else if (response.status === 204) listenerApi.dispatch(fetchNotAuthorizedInfo());
      } else throw response.message;
    })
    .catch((e) => console.error("Errore durante il recupero delle informazioni profilo:", e));
};

const inserisciProfiloWorker = (action, listenerApi) => {
  createRequest(INSERISCI_PROFILO_API.method, INSERISCI_PROFILO_API.baseUrl, INSERISCI_PROFILO_API.apiUrl, null, preparaDatiInserimento(action.payload)) //prettier-ignore
    .then((response) => {
      if (response != null && response.status != null && response.status === 200) window.location.href = window.origin;
      else throw response.message;
    })
    .catch((e) => {
      setTimeout(() => {
        listenerApi.dispatch(inserimentoProfiloFailed());
      }, 1000);
      console.error("Errore durante il salvataggio del nuovo profilo utente:", e);
    });
};

const aggiornaProfiloWorker = (action, listenerApi) => {
  const { payload, cambiRuoloScuola } = action.payload;
  createRequest(AGGIORNA_PROFILO_API.method, AGGIORNA_PROFILO_API.baseUrl, AGGIORNA_PROFILO_API.apiUrl, null, preparaDatiAggiornamento(payload)) //prettier-ignore
    .then((response) => {
      if (response != null && response.status != null && response.status === 200) {
        if (cambiRuoloScuola) {
          createRequest(AGGIORNA_RUOLO_ISTITUTO_API.method, AGGIORNA_RUOLO_ISTITUTO_API.baseUrl, AGGIORNA_RUOLO_ISTITUTO_API.apiUrl, null, preparaDatiAggiornamento(payload)) //prettier-ignore
            .then((response) => {
              if (response != null && response.status != null && response.status === 200) window.location.href = window.origin;
              else throw response.message;
            })
            .catch((e) => {
              setTimeout(() => {
                listenerApi.dispatch(inserimentoProfiloFailed());
              }, 1000);
              console.error("Errore durante il salvataggio del profilo utente:", e);
            });
        } else window.location.href = window.origin;
      } else throw response.message;
    })
    .catch((e) => {
      setTimeout(() => {
        listenerApi.dispatch(inserimentoProfiloFailed());
      }, 1000);
      console.error("Errore durante il salvataggio del profilo utente:", e);
    });
};

const fetchNotAuthorizedInfoWorker = (listenerApi) => {
  listenerApi.dispatch(fetchIstitutiScolastici());
  listenerApi.dispatch(fetchIncarichi());
  window.dispatchEvent(new CustomEvent(NOT_AUTHORIZED_EVENT));
};

const fetchIstitutiScolasticiWorker = (listenerApi) => {
  createRequest(ISTITUTI_SCOLASTICI_API.method, ISTITUTI_SCOLASTICI_API.baseUrl, ISTITUTI_SCOLASTICI_API.apiUrl)
    .then((response) => {
      if (response.status === 200) listenerApi.dispatch(fetchIstitutiScolasticiSuccess(preparaListaIstituti(response.data)));
      else throw response.message;
    })
    .catch((e) => {
      listenerApi.dispatch(fetchIstitutiScolasticiFailed());
      console.error("Errore durante il recupero degli istituti scolastici:", e);
    });
};

const fetchIncarichiWorker = (listenerApi) => {
  createRequest(INCARICHI_API.method, INCARICHI_API.baseUrl, INCARICHI_API.apiUrl)
    .then((response) => {
      if (response.status === 200) listenerApi.dispatch(fetchIncarichiSuccess(preparaListaIncarichi(response.data)));
      else throw response.message;
    })
    .catch((e) => {
      listenerApi.dispatch(fetchIncarichiFailed());
      console.error("Errore durante il recupero dei ruoli:", e);
    });
};

export const osservatorioMiddleware = createListenerMiddleware();

osservatorioMiddleware.startListening({
  actionCreator: getUserInfoSuccess,
  effect: async (action, listenerApi) => getUserInfoSuccessWorker(listenerApi),
});

osservatorioMiddleware.startListening({
  actionCreator: fetchProfilo,
  effect: async (action, listenerApi) => fetchProfiloWorker(listenerApi),
});

osservatorioMiddleware.startListening({
  actionCreator: inserisciProfilo,
  effect: async (action, listenerApi) => inserisciProfiloWorker(action, listenerApi),
});

osservatorioMiddleware.startListening({
  actionCreator: aggiornaProfilo,
  effect: async (action, listenerApi) => aggiornaProfiloWorker(action, listenerApi),
});

osservatorioMiddleware.startListening({
  actionCreator: fetchNotAuthorizedInfo,
  effect: async (action, listenerApi) => fetchNotAuthorizedInfoWorker(listenerApi),
});

osservatorioMiddleware.startListening({
  actionCreator: fetchIstitutiScolastici,
  effect: async (action, listenerApi) => fetchIstitutiScolasticiWorker(listenerApi),
});

osservatorioMiddleware.startListening({
  actionCreator: fetchIncarichi,
  effect: async (action, listenerApi) => fetchIncarichiWorker(listenerApi),
});
